import { Button } from 'components/shadcn/button';
import { IonIcon } from 'components/UI/IonIcon';
import linkDecorator from 'components/UI/linkDecorator';
import { useLanguage } from 'languages/languageContext';
import moment from 'moment';
import { cn } from 'utilities/utils';
import Linkify from 'react-linkify';
import { TPrice } from '../types';

// used to show active subscription for disabled plans
export const DeletedCard = ({
  product,
  unit_amount,
  currency,
  isActive,
  description,
  isOneTime,
  recurring,
  expireDate,
  cancelHandler,
}: Partial<TPrice> & {
  isActive?: boolean;
  description: string;
  isOneTime?: boolean;
  expireDate: string;
  cancelHandler: () => void;
}) => {
  const { subscription } = useLanguage();

  const duration = recurring?.interval
    ? `${recurring.interval_count > 1 ? recurring.interval_count + ' ' : ''}${subscription[recurring.interval]}`
    : `1 ${subscription.month}`;

  return (
    <>
      <div className="flex flex-row items-center gap-2">
        <IonIcon name="star" size={22} />
        <h2 className="text-lg font-medium">{subscription.subscriptionActive}</h2>
        <h2 className="text-sm/[30px]">
          ({subscription.until} {moment(expireDate).format('DD.MM.YYYY')})
        </h2>
      </div>
      <div
        className={cn(
          'border-2 rounded-md w-full p-3 hover:scale-[102%] duration-150',
          isActive && 'border-primary-btn',
        )}
      >
        <div className="flex flex-row justify-between items-center pb-2">
          <h3 className="font-medium">{product?.name}</h3>
          <h3 className="font-regular text-sm">
            {(unit_amount / 100).toFixed(2)} {currency?.toUpperCase()}/{duration}
          </h3>
        </div>
        <Linkify componentDecorator={linkDecorator}>{description}</Linkify>
        <Button disabled className="text-sm h-8 my-2 bg-gray-300">
          {subscription.subscriptionActive}
        </Button>

        {isOneTime && (
          <Button className="text-sm h-8 my-2 bg-slate-500 opacity-0" onClick={() => {}} disabled={true}>
            (bereits benutzt)
          </Button>
        )}
      </div>
      <Button className="bg-red-600 my-2" onClick={cancelHandler}>
        {subscription.cancel.cancel}
      </Button>
    </>
  );
};
